module.exports = __webpack_public_path__ + "img/1f918-1f3fb.126fda8.svg";